import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.equineSnow,
  fillHoverColor: colors.equineSnow,
  iconColor: colors.equineIron,
  iconHoverColor: colors.equineStone,
  iconBorderColor: colors.equineIron,
  iconBorderHoverColor: colors.equineStone
};
export default socialIcon;